import {
  type AdvancedFilterFormData,
  type AdvancedFilterOptions,
  type FilterOption,
  type FilterSection,
} from '../types/advanced-filter-form-data';

export const getDefaultValueObjectFromFilterOptions = (
  filterOptions: AdvancedFilterOptions,
  overrideValue?: boolean
) => {
  const defaultValueObject = {} as AdvancedFilterFormData;

  for (const [sectionKey, sectionFilterOptions] of Object.entries(filterOptions) as Array<
    [FilterSection, FilterOption[]]
  >) {
    defaultValueObject[sectionKey] = Object.fromEntries(
      sectionFilterOptions.map(({ defaultValue, name }) => [
        name,
        Boolean(overrideValue ?? defaultValue),
      ])
    );
  }

  return defaultValueObject;
};
